<div class="bmc-triggers-interface__container" *ngIf="selectedTriggerConn">
  <div class="bmc-triggers-interface__header">
    <div class="bmc-triggers-interface__display-name">
      <div class="card-logo">
        <img src="assets/icons/16x16_dropbox.svg" *ngIf="selectedTriggerConn.serviceName ==  'dropbox'" />
        <img src="assets/icons/16x16_sharepoint.svg" *ngIf="selectedTriggerConn.serviceName ==  'sharepoint'" />
      </div>
      <label class="bmc-triggers-interface__display-name__text">{{selectedTriggerConn.displayName}} </label>
    </div>
  </div>

  <div class="enabled-switch-environment">
    <bzg-switch [(ngModel)]='selectedTriggerConn.environment.currentEnvironment.isEnabled'
      (change)="updateModel(selectedTriggerConn.environment.currentEnvironment.isEnabled)"
      [ngClass]="selectedTriggerConn.environment.currentEnvironment.isEnabled ? '' : 'bz-switch--disabled'"></bzg-switch>
    <div class="lbl-switch">{{'TRIGGERS.ENABLED_TXT' | translate}}</div>
  </div>
  <div class="bmc-triggers-interface__tabs-section">
    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}"
        displayName="{{'TRIGGERS.AUTH_PARAMETERS' | translate | uppercase}}">
        <div class="bmc-triggers-auth-fields">
          <div [ngClass]="selectedTriggerConn.environment.currentEnvironment.isEnabled ? '' : 'bz-switch--disabled'">
          <bzg-table [(model)]="authPropertiesShow" [cellSpacingMode]="cellSpacingMode">
            <ng-template bzgTableColumn width="40%" title="Name" let-dataItem="dataItem" [allowOrder]="false">
              <bzg-checkbox *ngIf="dataItem.canDelete" [(ngModel)]="dataItem.selected"
                style="vertical-align: baseline;">
              </bzg-checkbox>
              <bzg-input *ngIf="dataItem.canDelete" [(ngModel)]="dataItem.name" [compact]="'true'">
              </bzg-input>
              <span *ngIf="!dataItem.canDelete && !dataItem.hidden">
                <p style="font-weight:600">{{dataItem.displayName}}</p>
              </span>
              <span *ngIf="dataItem.required && dataItem.canEdit">
                <p style="font-weight:600">*</p>
              </span>
            </ng-template>
            <ng-template bzgTableColumn width="60%" title="Value" let-dataItem="dataItem" [allowOrder]="false">
              <bzg-input *ngIf="!dataItem.hidden" [(ngModel)]="dataItem.value" [required]="dataItem.required"
                [readonly]="!dataItem.canEdit" [compact]="'true'" class="input-properties" style="width: 100%;"
                type="{{dataItem.passwordmode ? 'password':'text'}}" title="{{dataItem.title}}"
                [pattern]="dataItem.pattern" (change)="changeProperty($event)" [disabled]="dataItem.disabled">
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD'|translate}}</bzg-required-error>
                <bzg-pattern-error>{{'GLOBAL.IS_NOT_VALID'|translate}}</bzg-pattern-error>
              </bzg-input>
              <img src="assets/icons/16x_restart.svg" class="copy-style" title="{{'COMMON.RESTART_VALUE' | translate}}"
                (click)=restartValue(dataItem.name) *ngIf="dataItem.restart">
              <img src="assets/icons/16x_copy.svg" class="copy-style" title="{{'COMMON.COPY_TEXT' | translate}}"
                (click)=copyToclipboard(dataItem.value) *ngIf="dataItem.copy">
            </ng-template>
          </bzg-table>
        </div>
          <div class="select-oauth" *ngIf="needAuthorize" >
            <bzg-button-secondary class="bz-space--inline-m" (click)="authorize()"
            [disabled] = "!selectedTriggerConn.environment.currentEnvironment.isEnabled">
              <span>{{'CONNECTORS.AUTHORIZE'|translate}}
                <img src="assets/icons/12x_check-mark.svg" *ngIf="authenticated()" style="vertical-align: middle;">
              </span>
            </bzg-button-secondary>
          </div>
        </div>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>
</div>

<biz-auth-code-grant #authcodegrant (onOauthData)="onOauthData($event)"></biz-auth-code-grant>